export const asset = (path: string) => path;
